import { render, staticRenderFns } from "./side.vue?vue&type=template&id=1908f1b3&scoped=true&"
import script from "./side.vue?vue&type=script&lang=js&"
export * from "./side.vue?vue&type=script&lang=js&"
import style0 from "./side.vue?vue&type=style&index=0&id=1908f1b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1908f1b3",
  null
  
)

component.options.__file = "side.vue"
export default component.exports